import { brregApiEndpoints } from '@config/apis/brreg/brreg-api-endpoints';
import { createApiConfiguration } from '@fagforbundet/ngx-components';

export const brregApiConfig = createApiConfiguration<typeof brregApiEndpoints>({
  baseUrl: 'https://data.brreg.no/enhetsregisteret/api',
  endpoints: brregApiEndpoints,
});
